import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from './components/ScrollToTop';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { ContactDialog } from './components/ContactDialog';
import { Home } from './pages/Home';
import { Economics } from './pages/Economics';
import { UseCases } from './pages/UseCases';
import { Technology } from './pages/Technology';
import { Process } from './pages/Process';
import { FAQ } from './pages/FAQ';
import { About } from './pages/About';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { Barrierefreiheit } from './pages/Barrierefreiheit';

function App() {
  const [contactOpen, setContactOpen] = useState(false);

  const handleContactClick = () => {
    setContactOpen(true);
  };

  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar onContactClick={handleContactClick} />
        <Routes>
          <Route path="/" element={<Home onContactClick={handleContactClick} />} />
          <Route path="/wirtschaftlichkeit" element={<Economics onContactClick={handleContactClick} />} />
          <Route path="/anwendungsfaelle" element={<UseCases onContactClick={handleContactClick} />} />
          <Route path="/technologie" element={<Technology onContactClick={handleContactClick} />} />
          <Route path="/prozess" element={<Process onContactClick={handleContactClick} />} />
          <Route path="/faq" element={<FAQ onContactClick={handleContactClick} />} />
          <Route path="/ueber-uns" element={<About onContactClick={handleContactClick} />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/barrierefreiheit" element={<Barrierefreiheit />} />
        </Routes>
        <Footer onContactClick={handleContactClick} />
        <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
      </BrowserRouter>
    </div>
  );
}

export default App;
